import React, { useState } from 'react';
import ShareContentToolbar from '../share_content_toolbar/share_content_toolbar';
import styles from './news_details_share_toolbar_hoc.module.scss';
import AlertPopup from '../../components/react/alert_popup/alert_popup';
import { AlertDataType } from '../../components/react/alert_popup/types';

const TARGET_TYPE = 'Article';

interface Props {
  contentId: number;
  contentUrl: string;
  contentTitle: string;
  contentTeaser: string;
  showSharingArticle: boolean;
  isContentPaywalled: boolean;
}

const NewsDetailsShareToolbarHOC = (props: Props): JSX.Element => {
  const [alertData, setAlertData] = useState<AlertDataType | null>(null);

  const {
    contentId,
    contentUrl,
    contentTitle,
    contentTeaser,
    showSharingArticle,
    isContentPaywalled,
  } = props;

  const renderDesktopToolbar: JSX.Element = (
    <div className={`${styles.desktop} d-none d-lg-block d-print-none mt-15`}>
      <div className={styles.desktopToolbar} data-testid='news-details-desktop-share-toolbar'>
        <ShareContentToolbar
          contentId={contentId}
          contentUrl={contentUrl}
          contentTitle={contentTitle}
          contentTeaser={contentTeaser}
          displayDevexShareFeature={showSharingArticle}
          displayPrintIcon={!isContentPaywalled}
          targetType={TARGET_TYPE}
          setAlertData={setAlertData}
        />
      </div>
    </div>
  );

  const renderMobileToolbar: JSX.Element = (
    <div
      className={`
        align-items-center sticky-top d-inline-flex d-lg-none mt-15 d-print-none text-center
        ${styles.mobile}
      `}
      data-testid='news-details-mobile-share-toolbar'
    >
      <ShareContentToolbar
        contentId={contentId}
        contentUrl={contentUrl}
        contentTitle={contentTitle}
        contentTeaser={contentTeaser}
        displayDevexShareFeature={showSharingArticle}
        displayPrintIcon={!isContentPaywalled}
        targetType={TARGET_TYPE}
        setAlertData={setAlertData}
      />
    </div>
  );

  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      {renderDesktopToolbar}
      {renderMobileToolbar}
    </>
  );
};

export default NewsDetailsShareToolbarHOC;
